
import React from 'react';
import { Badge } from "@/components/ui/badge";

export const getStatusBadge = (status: string) => {
  const statusConfig = {
    'active': {
      color: 'bg-green-500/20 text-green-300 text-[9.5px] border-green-500/50',
      label: 'Active'
    },
    'paused': {
      color: 'bg-yellow-500/20 text-yellow-300 text-[9.5px] border-yellow-500/50',
      label: 'Paused'
    },
    'completed': {
      color: 'bg-blue-500/20 text-blue-300 text-[9.5px] border-blue-500/50',
      label: 'Completed'
    },
    'cancelled': {
      color: 'bg-red-500/20 text-red-300 text-[9.5px] border-red-500/50',
      label: 'Cancelled'
    }
  };
  const config = statusConfig[status as keyof typeof statusConfig] || statusConfig.active;
  return <Badge className={config.color}>{config.label}</Badge>;
};

export const getPriorityBadge = (priority: string) => {
  const priorityConfig = {
    'high': {
      color: 'bg-red-500/20 text-red-300 text-[9.5px] border-red-500/50',
      label: 'High'
    },
    'medium': {
      color: 'bg-yellow-500/20 text-yellow-300 text-[9.5px] border-yellow-500/50',
      label: 'Medium'
    },
    'low': {
      color: 'bg-green-500/20 text-green-300 text-[9.5px] border-green-500/50',
      label: 'Low'
    }
  };
  const config = priorityConfig[priority as keyof typeof priorityConfig] || priorityConfig.medium;
  return <Badge className={config.color}>{config.label}</Badge>;
};

export const getCategoryBadge = (category: string) => {
  const categoryConfig = {
    'financial': {
      color: 'bg-emerald-500/20 text-emerald-300 text-[9.5px] border-emerald-500/50',
      label: 'Financial'
    },
    'project_delivery': {
      color: 'bg-blue-500/20 text-blue-300 text-[9.5px] border-blue-500/50',
      label: 'Project Delivery'
    },
    'customer_impact': {
      color: 'bg-purple-500/20 text-purple-300 text-[9.5px] border-purple-500/50',
      label: 'Customer Impact'
    },
    'innovation': {
      color: 'bg-orange-500/20 text-orange-300 text-[9.5px] border-orange-500/50',
      label: 'Innovation'
    },
    'leadership_behaviors': {
      color: 'bg-pink-500/20 text-pink-300 text-[9.5px] border-pink-500/50',
      label: 'Leadership'
    }
  };
  const config = categoryConfig[category as keyof typeof categoryConfig] || categoryConfig.financial;
  return <Badge className={config.color}>{config.label}</Badge>;
};

export const getProgressColor = (progress: number) => {
  if (progress >= 90) return 'text-green-400 text-[9.5px]';
  if (progress >= 70) return 'text-yellow-400 text-[9.5px]';
  if (progress >= 50) return 'text-orange-400 text-[9.5px]';
  return 'text-red-400 text-[9.5px]';
};
